import { render, staticRenderFns } from "./Oa.vue?vue&type=template&id=3a4755de&scoped=true"
import script from "./Oa.vue?vue&type=script&lang=js"
export * from "./Oa.vue?vue&type=script&lang=js"
import style0 from "./Oa.vue?vue&type=style&index=0&id=3a4755de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4755de",
  null
  
)

export default component.exports